<div class="dock-panel" [style.width.px]="panelWidth">
  <div class="dock-header">
    <span>{{'document.Preview' | translate}}</span>
    <div class="zoom-controls">
        <button  *ngIf="isImage(selectedDocument)" class="preview-btn rotate" (click)="rotateImage($event)"  matTooltip="Rotate document">
            <fa-icon icon="rotate-right"></fa-icon>
        </button>
      <button class="preview-btn close" (click)="closePreview()" matTooltip="Close preview">
        <fa-icon icon="xmark"></fa-icon>
      </button>
    </div>
  </div>
  <div class="dock-body" (wheel)="onWheelZoom($event)">
    <div *ngIf="isImage(selectedDocument)" class="zoom-container" [style.transform]="'scale(' + zoomLevel + ') rotate(' + rotation + 'deg)'">
      <img [src]="selectedDocument" alt="Document" draggable="false" />
    </div>
    <ngx-extended-pdf-viewer *ngIf="isPDF(selectedDocument)" [src]="selectedDocument" class="pdf-frame" height="70vh" rotation="0.0"></ngx-extended-pdf-viewer>
  </div>
  <div class="resize-bar" (mousedown)="startResize($event)"></div>
  <div class="resize-bar-horizontal" (mousedown)="startResize($event, 'vertical')"></div>
</div>
